"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var index_1 = __importDefault(require("./index"));
var react_1 = require("@emotion/react");
var react_2 = require("react");
var design_system_colors_1 = require("../../style/theme/design-system-colors");
var TITLE_SIZE_TO_STYLE = {
    sm: '0.75rem',
    default: '0.875rem',
    lg: '1rem',
    xl: '1.125rem',
};
var createTitleStyle = function (size, uppercase, color) {
    return react_1.css({
        textTransform: uppercase === true ? 'uppercase' : 'none',
        color: color,
        fontSize: TITLE_SIZE_TO_STYLE[size],
        fontWeight: 600,
    });
};
var Title = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, children = _a.children, _c = _a.uppercase, uppercase = _c === void 0 ? false : _c, _d = _a.color, color = _d === void 0 ? design_system_colors_1.DesignSystemThemeColor.Gray.DARK_4 : _d, props = __rest(_a, ["size", "children", "uppercase", "color"]);
    var titleStyle = react_2.useMemo(function () { return createTitleStyle(size, uppercase, color); }, [size, uppercase, color]);
    return react_1.jsx(index_1.default, __assign({ css: titleStyle }, props), children);
};
exports.default = Title;
